import { ApiError } from '@/api/client'

const messages: Record<string, string> = {
  CANCELLATION_PREVIEW_CHANGED: 'Abo-Ende, Vormerkung oder betroffene Buchungen haben sich geändert. Bitte prüfe die neue Kündigungsvorschau.',
  CANCELLATION_PREVIEW_EXPIRED: 'Die Kündigungsvorschau ist abgelaufen. Bitte öffne sie erneut.',
  CANCELLATION_CONFIRMATION_REQUIRED: 'Bitte bestätige die Kündigung und ihre Folgen ausdrücklich.',
  // Members (own subscription) and admins (sessions or subscriptions of a member) see this.
  CANCELLATION_IN_PROGRESS:
    'Eine Abo-Kündigung wird gerade mit Stripe abgeglichen. Bis dahin können das Abo nicht geändert und betroffene Termine nicht verschoben werden. Bitte versuche es in ein paar Minuten erneut – der Abgleich wird automatisch stündlich wiederholt.',
  CANCELLATION_FAILED: 'Die Kündigungsaktion konnte nicht abgeschlossen werden. Deine Buchungen wurden durch diesen Versuch nicht storniert.',
  CONDITIONS_PREVIEW_CHANGED: 'Die Konditionen oder betroffenen Buchungen haben sich geändert. Bitte die aktualisierte Vorschau erneut prüfen.',
  CONDITIONS_PACKAGE_MISMATCH: 'Die Konditionsversion gehört nicht zu diesem Abo.',
  SUBSCRIPTION_PERIOD_UNAVAILABLE: 'Für dieses Abo ist derzeit kein zukünftiger Abrechnungstermin bekannt. Bitte den Zahlungsstatus abgleichen.',
  SUBSCRIPTION_PERIOD_CHANGED: 'Der Abrechnungstermin hat sich geändert. Bitte die Konditionsübernahme neu prüfen.',
  BOOKED_SESSION_COURSE_IMMUTABLE: 'Der Kurs eines gebuchten Termins kann nicht geändert werden. Bitte die Buchungen zuerst klären.',

  COURSE_APPROVAL_REQUIRED: 'Für diesen Kurs ist der Kunde noch nicht freigeschaltet.',
  COURSE_TERMS_REQUIRED: 'Bitte zuerst die aktuellen Kurs-AGB akzeptieren.',
  COURSE_TERMS_TEXT_REQUIRED: 'Wenn das Akzeptieren der Kurs-AGB vor der Buchung erforderlich ist, muss ein AGB-Text hinterlegt sein.',
  COURSE_TERMS_CHANGED: 'Die Kurs-AGB wurden geändert. Bitte öffne die Buchung erneut.',
  GUESTS_NOT_ALLOWED: 'Dieser Kurs erlaubt keine Gasteinladungen.',
  GUEST_NOT_FOUND: 'Kein aktiver Kunde mit dieser E-Mail-Adresse gefunden.',
  GUEST_LIMIT_REACHED: 'Alle Gastplätze sind bereits belegt oder reserviert.',
  GUEST_ALREADY_INVITED: 'Dieser Kunde wurde bereits eingeladen.',
  CANNOT_INVITE_SELF: 'Du kannst dich nicht selbst einladen.',
  INVITATION_NOT_ACTIVE: 'Diese Einladung ist nicht mehr offen.',
  BOOKING_NOT_ACTIVE: 'Die Buchung ist nicht mehr aktiv oder der Termin hat begonnen.',
  ACCESS_PREVIEW_CHANGED: 'Die betroffenen Buchungen haben sich geändert. Bitte prüfe die aktualisierte Übersicht.',
  CREDIT_TYPE_INACTIVE: 'Diese Credit-Art ist für neue Käufe deaktiviert.',
  PLAN_PREVIEW_CHANGED: 'Preis, Konditionen, Vormerkung oder betroffene Buchungen haben sich geändert. Bitte prüfe die aktualisierte Vorschau.',
  PLAN_PREVIEW_EXPIRED: 'Die Preisvorschau ist abgelaufen. Bitte öffne den Abo-Wechsel erneut.',
  SUBSCRIPTION_PAYMENT_PENDING: 'Für dein Abo ist noch eine Tarifwechsel-Zahlung offen. Bitte kläre sie zuerst.',
  SUBSCRIPTION_CANCELLATION_PENDING: 'Dein Abo ist bereits gekündigt. Bitte nimm die Kündigung unter „Mein Abo“ zurück, bevor du den Tarif wechselst.',
  SUBSCRIPTION_CHANGE_UNAVAILABLE: 'Die gewünschte Abo-Änderung ist derzeit nicht möglich. Bitte kontaktiere uns.',
  PLAN_CONFIRMATION_REQUIRED: 'Bitte bestätige die Stornierungen und das Ersetzen der Vormerkung ausdrücklich.',
  PLAN_STRIPE_STATE_UNCONFIRMED: 'Der Tarifwechsel wurde von Stripe noch nicht bestätigt.',
  SUBSCRIPTION_SCHEDULE_CONFLICT: 'Für dieses Abo besteht bereits eine andere geplante Änderung. Bitte kontaktiere den Admin.',
  SUBSCRIPTION_CHANGE_IN_PROGRESS: 'Dein Tarifwechsel wird bereits verarbeitet. Bitte warte kurz und lade den Abo-Bereich erneut.',
  PURCHASE_CONDITIONS_UNAVAILABLE: 'Die ursprünglich vereinbarten Paketleistungen konnten nicht eindeutig ermittelt werden. Bitte kontaktiere den Admin.',

  SESSION_FULL: 'Der Termin ist leider bereits ausgebucht.',
  ALREADY_BOOKED: 'Sie sind für den gewählten Termin bereits registriert.',
  SESSION_NOT_FOUND: 'Der Termin wurde nicht gefunden.',
  SESSION_NOT_BOOKABLE: 'Der Termin ist nicht mehr buchbar.',
  EMAIL_REQUIRED: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  NAME_REQUIRED: 'Bitte gib deinen vollständigen Namen ein.',
  USER_NOT_FOUND: 'Kein Auth-User mit dieser E-Mail gefunden.',
  UNAUTHORIZED: 'Du bist für diese Aktion nicht berechtigt.',
  TRAINER_INVALID: 'Der ausgewählte Trainer ist ungültig oder inaktiv.',
  EMAIL_ALREADY_REGISTERED: 'Für diese E-Mail existiert bereits ein Benutzerkonto.',
  ROLE_INVALID: 'Die ausgewählte Rolle ist ungültig.',
  PASSWORD_TOO_SHORT: 'Das Initialpasswort ist zu kurz (mindestens 6 Zeichen).',
  USER_CREATION_FAILED: 'Der Benutzer konnte nicht angelegt werden.',
  USER_UPDATE_FAILED: 'Der Benutzer konnte nicht aktualisiert werden.',
  STATUS_INVALID: 'Der Aktivstatus ist ungültig.',
  SESSION_TIME_INVALID: 'Bitte gib einen gültigen Beginn an; das Ende muss nach dem Beginn liegen.',
  SESSION_PARTICIPANTS_INVALID:
    'Die maximale Teilnehmerzahl muss mindestens 1 sein, die Mindestteilnehmerzahl darf sie nicht übersteigen.',
  SESSION_HAS_BOOKINGS: 'Der Termin kann nicht gelöscht werden, da bereits Buchungen existieren.',
  CATEGORY_REQUIRED: 'Bitte eine Kategorie auswählen.',
  BOOKING_CREDIT_STATE_INVALID: 'Die frühere Buchung hat noch Credit-Zuordnungen. Bitte den Support kontaktieren.',
  INVITATION_NOT_FOUND: 'Die Einladung wurde nicht gefunden.',
  PURCHASED_CREDITS_IMMUTABLE: 'Die gekaufte Credit-Menge eines Pakets kann nicht geändert werden.',
  INVALID_CHANGE_STATE: 'Ungültiger Status für den Tarifwechsel.',
  INVALID_REQUEST: 'Die Anfrage ist unvollständig oder ungültig. Bitte lade die Seite neu und versuche es erneut.',
  MAX_GUESTS_INVALID: 'Die Anzahl der Gäste pro Buchung muss zwischen 0 und 20 liegen.',
  COURSE_IMAGE_URL_INVALID: 'Das Kursbild wurde nicht über die App hochgeladen. Bitte das Bild erneut hochladen.',
  COURSE_NOT_FOUND: 'Der Kurs wurde nicht gefunden.',
  INVALID_REGISTRATION_HOURS: 'Die Anmeldefrist darf nicht negativ sein.',
  INVALID_CALENDAR_TAG_FILTER_MODE: 'Unbekannte Darstellung des Tag-Filters.',
  SESSION_ALREADY_BILLED: 'Der Termin ist bereits in einer Honorarnote abgerechnet. Bitte zuerst die Honorarnote stornieren.',
  NOT_FOUND: 'Eintrag wurde nicht gefunden.',
  ACCOUNT_INACTIVE: 'Dein Konto ist deaktiviert. Bitte kontaktiere einen Admin.',
  // Account and API errors of the ASP.NET Core backend.
  INVALID_CREDENTIALS: 'E-Mail-Adresse oder Passwort ist falsch.',
  TOO_MANY_LOGIN_ATTEMPTS: 'Zu viele Fehlversuche. Bitte warte 15 Minuten oder setze dein Passwort zurück.',
  EMAIL_NOT_CONFIRMED: 'Bitte bestätige zuerst deine E-Mail-Adresse über den Link in unserer E-Mail.',
  CONFIRMATION_LINK_INVALID: 'Der Bestätigungslink ist ungültig oder abgelaufen. Fordere beim Login einen neuen an.',
  RESET_LINK_INVALID: 'Der Link ist ungültig oder abgelaufen. Bitte fordere einen neuen an.',
  PASSWORD_RESET_FAILED: 'Das Passwort konnte nicht gesetzt werden. Bitte versuche es erneut.',
  PASSWORD_CHANGE_FAILED: 'Das Passwort konnte nicht geändert werden. Bitte versuche es erneut.',
  CURRENT_PASSWORD_INVALID: 'Das aktuelle Passwort ist nicht korrekt.',
  PHONE_NUMBER_REQUIRED: 'Bitte gib deine Telefonnummer ein.',
  FIRST_AND_LAST_NAME_REQUIRED: 'Bitte Vor- und Nachnamen angeben.',
  CANNOT_DELETE_SELF: 'Du kannst dein eigenes Konto nicht löschen.',
  CANNOT_CHANGE_OWN_ACCESS: 'Du kannst deine eigene Rolle und deinen Status nicht ändern.',
  USER_DELETE_BLOCKED: 'Der Benutzer hat Buchungen, Guthaben oder Zahlungen und kann nicht gelöscht werden. Deaktiviere ihn stattdessen.',
  AVATAR_URL_INVALID: 'Das Profilbild ist ungültig. Bitte lade es erneut hoch.',
  FILE_REQUIRED: 'Bitte wähle eine Datei aus.',
  FILE_TOO_LARGE: 'Die Datei ist zu groß.',
  FILE_TYPE_NOT_SUPPORTED: 'Bitte lade ein Bild im Format JPG, PNG, WebP oder GIF hoch.',
  TOO_MANY_REQUESTS: 'Zu viele Anfragen. Bitte warte einen Moment.',
  VALIDATION_FAILED: 'Bitte prüfe deine Eingaben.',
  DUPLICATE: 'Dieser Eintrag existiert bereits.',
  CONCURRENCY_CONFLICT: 'Der Eintrag wurde inzwischen geändert. Bitte lade die Seite neu.',
  CONSTRAINT_VIOLATION: 'Die Eingaben verletzen eine Regel. Bitte prüfe sie.',
  REFERENCED_RECORD_CONFLICT: 'Der Eintrag wird noch verwendet und kann nicht geändert oder gelöscht werden.',
  CSRF_HEADER_MISSING: 'Die Anfrage wurde aus Sicherheitsgründen abgelehnt. Bitte lade die Seite neu.',
  STRIPE_SECRET_MISSING: 'Stripe ist nicht konfiguriert. Bitte den Stripe-Schlüssel des Backends prüfen.',
  CREDIT_AMOUNT_INVALID: 'Bitte gib eine Credit-Anzahl in Schritten von 0,1 an.',
  BENEFIT_INVALID: 'Mindestens eine Leistung ist ungültig: Credit-Art aktiv, Pakete nur Guthaben, Abos nur Wochenkontingent oder unbegrenzt, Mengen in Schritten von 0,1.',
  BENEFITS_REQUIRED: 'Bitte mindestens eine Leistung angeben.',
  TOO_MANY_WEEKS: 'Es können höchstens 100 Wochen auf einmal abgefragt werden.',
  CREDIT_TYPE_CODE_INVALID: 'Der Code darf nur Kleinbuchstaben, Ziffern und Unterstriche enthalten und muss mit einem Buchstaben beginnen.',
  CREDIT_TYPE_CODE_DUPLICATE: 'Diesen Code gibt es bereits.',
  CREDIT_TYPE_NAME_REQUIRED: 'Bitte einen Namen für die Credit-Art angeben.',
  CREDIT_TYPE_NOT_FOUND: 'Diese Credit-Art gibt es nicht.',
  VOUCHER_ALREADY_USED: 'Die Credit-Art kann nach der ersten Einlösung nicht mehr geändert werden.',
  NO_ACTIVE_SUBSCRIPTION: 'Du hast kein aktives Abo. Bitte wähle ein Kurspaket.',
  INSUFFICIENT_CREDITS:
    'Dein Abo und dein zusätzliches Creditguthaben reichen für diesen Kurs nicht aus.',
  SESSION_CANCELLED: 'Dieser Termin wurde storniert.',
  SESSION_IN_PAST: 'Dieser Kurs liegt in der Vergangenheit und kann nicht mehr gebucht werden.',
  REGISTRATION_DEADLINE_PASSED: 'Die Anmeldefrist für diesen Kurs ist abgelaufen.',
  INVALID_PACKAGE: 'Das gewählte Paket ist nicht verfügbar.',
  PACKAGE_STRIPE_PRICE_MISSING: 'Für dieses Paket ist noch kein Stripe-Preis hinterlegt.',
  PACKAGE_NAME_INVALID: 'Bitte gib einen Namen mit 2 bis 100 Zeichen ein.',
  PACKAGE_PRICE_INVALID: 'Bitte gib einen gültigen Preis ein.',
  PACKAGE_WEEKLY_LIMIT_INVALID:
    'Bitte gib ein Wochen-Creditlimit in 0,1-Schritten ein oder lasse das Feld für unbegrenzt leer.',
  PACKAGE_DISPLAY_ORDER_INVALID: 'Bitte gib eine gültige Sortierposition ein.',
  PACKAGE_BILLING_MODE_INVALID: 'Die Angebotsart ist ungültig.',
  PACKAGE_BILLING_MODE_IMMUTABLE:
    'Die Angebotsart kann nach dem Anlegen nicht mehr geändert werden.',
  PACKAGE_STRIPE_PRICE_REQUIRED:
    'Für ein aktives Angebot muss eine Stripe-Preis-ID hinterlegt werden.',
  PACKAGE_STRIPE_PRICE_INVALID: 'Die Stripe-Preis-ID ist ungültig.',
  PACKAGE_STRIPE_PRICE_INACTIVE: 'Der hinterlegte Stripe-Preis ist nicht aktiv.',
  PACKAGE_STRIPE_CURRENCY_INVALID: 'Der Stripe-Preis muss in EUR angelegt sein.',
  PACKAGE_STRIPE_AMOUNT_MISMATCH:
    'Der eingegebene Betrag stimmt nicht mit dem Stripe-Preis überein.',
  PACKAGE_STRIPE_MODE_MISMATCH:
    'Einmaliges Paket und Stripe-Abrechnungsart stimmen nicht überein.',
  PACKAGE_STRIPE_INTERVAL_INVALID:
    'Abos benötigen einen monatlich wiederkehrenden Stripe-Preis.',
  PACKAGE_NOT_FOUND: 'Das Angebot wurde nicht gefunden.',
  PACKAGE_DELETE_REQUIRES_ARCHIVE: 'Nur archivierte Angebote können gelöscht werden.',
  PACKAGE_IN_USE: 'Dieses Angebot wurde bereits verwendet und kann nicht gelöscht werden.',
  PACKAGE_ORDER_REQUIRED: 'Für die Sortierung wurden keine Angebote übergeben.',
  PACKAGE_ORDER_DUPLICATE: 'Die Sortierung enthält ein Angebot mehrfach.',
  PACKAGE_ORDER_INVALID: 'Die Sortierung enthält ein ungültiges oder archiviertes Angebot.',
  PACKAGE_PRICE_ROLLOUT_UNAVAILABLE:
    'Der aktuelle Preis kann für dieses Abo nicht auf Bestandsabos ausgerollt werden.',
  ACTIVE_SUBSCRIPTION_REQUIRED:
    'Für dieses Mitglied wurde kein aktualisierbares aktives Stripe-Abo gefunden.',
  CHECKOUT_SESSION_CREATE_FAILED: 'Checkout konnte nicht gestartet werden. Bitte versuche es erneut.',
  INVOICE_NOT_FOUND: 'Die Rechnung wurde nicht gefunden.',
  INVOICE_PDF_UNAVAILABLE: 'Für diese Rechnung ist aktuell kein Download verfügbar.',
  INVOICE_DOCUMENT_UNAVAILABLE: 'Für diesen Eintrag ist kein Rechnungsdokument verfügbar.',
  PLAN_CHANGE_REQUIRES_PORTAL:
    'Bitte wähle den geprüften Abo-Wechsel in der App.',
  ALREADY_ACTIVE_PACKAGE: 'Dieses Paket ist bereits aktiv.',
  NOT_AUTHENTICATED: 'Bitte melde dich erneut an.',
  BOOKING_NOT_FOUND: 'Die Buchung wurde nicht gefunden oder gehört nicht zu deinem Konto.',
  CANCELLATION_DEADLINE_PASSED: 'Die Stornierungsfrist ist abgelaufen.',
  CREDIT_DELTA_INVALID: 'Bitte gib Credits in 0,1-Schritten größer 0 an.',
  CREDIT_REASON_REQUIRED: 'Bitte gib einen Grund für die manuelle Guthabenänderung an.',
  PAYMENT_AMOUNT_INVALID: 'Bitte gib einen gültigen bezahlten Betrag an.',
  PAID_TOPUP_REQUIRES_STRIPE_INVOICE:
    'Bezahlte manuelle Aufbuchungen müssen über die Stripe-Rechnung erfolgen.',
  OPERATION_KEY_REQUIRED:
    'Für diese manuelle Aufbuchung fehlt der eindeutige Vorgangsschlüssel.',
  CREDIT_GRANT_CONFLICT:
    'Diese Aufbuchung wurde bereits mit anderen Angaben verarbeitet. Bitte lade die Seite neu und prüfe das Guthaben.',
  VOUCHER_CODE_REQUIRED: 'Bitte gib einen Gutschein-Code ein.',
  VOUCHER_NOT_FOUND: 'Dieser Gutschein-Code ist ungültig.',
  VOUCHER_EXHAUSTED: 'Dieser Gutschein-Code wurde bereits vollständig eingelöst.',
  VOUCHER_ALREADY_REDEEMED: 'Du hast diesen Gutschein-Code bereits eingelöst.',
  VOUCHER_CODE_INVALID:
    'Bitte gib einen gültigen Gutschein-Code ein. Erlaubt sind Buchstaben, Zahlen und Bindestriche.',
  VOUCHER_CODE_DUPLICATE: 'Dieser Gutschein-Code existiert bereits.',
  VOUCHER_CREDITS_INVALID: 'Bitte gib Gutschein-Credits in 0,1-Schritten größer 0 an.',
  VOUCHER_REDEMPTIONS_INVALID:
    'Bitte gib eine gültige maximale Anzahl an Einlösungen für den Gutschein an.',
  VOUCHER_REDEMPTIONS_BELOW_USAGE:
    'Die maximale Anzahl darf nicht unter den bereits erfolgten Einlösungen liegen.',
  VOUCHER_REDEEMED_FIELDS_LOCKED:
    'Bei bereits eingelösten Gutscheinen kann nur die maximale Anzahl an Einlösungen geändert werden.',
  VOUCHER_DELETE_REDEEMED:
    'Dieser Gutschein wurde bereits eingelöst und kann nicht gelöscht werden.',
  VOUCHER_CODE_GENERATION_FAILED:
    'Der Gutschein-Code konnte nicht erzeugt werden. Bitte versuche es erneut.',
  STRIPE_ENV_MISSING: 'Die Stripe-Konfiguration ist unvollständig.',
  STRIPE_CUSTOMER_REQUIRED: 'Der Stripe-Kunde für diese Aufbuchung fehlt.',
  STRIPE_INVOICE_REQUIRED: 'Die Stripe-Rechnung für diese Aufbuchung fehlt.',
  PASSWORDS_DO_NOT_MATCH: 'Die Passwörter stimmen nicht überein.',
  INVALID_CANCELLATION_HOURS: 'Bitte gib eine gültige Stundenzahl ab 0 ein.',
  ANNOUNCEMENT_NOT_FOUND: 'Die Benachrichtigung wurde nicht gefunden.',
  ANNOUNCEMENT_LOCKED:
    'Veröffentlichte Benachrichtigungen können nicht bearbeitet werden. Bitte zuerst zurückziehen.',
  ANNOUNCEMENT_EXPIRED: 'Das Sichtbar-bis-Datum liegt in der Vergangenheit.',
  ANNOUNCEMENT_INVALID_STATUS: 'Diese Aktion ist im aktuellen Status nicht möglich.',
  ANNOUNCEMENT_NOT_AVAILABLE: 'Diese Benachrichtigung ist nicht mehr verfügbar.',
  FEEDBACK_FORBIDDEN: 'Nur Teilnehmer können Feedback senden.',
  POLL_NOT_FOUND: 'Die Umfrage wurde nicht gefunden.',
  POLL_NOT_AVAILABLE: 'An dieser Umfrage kann nicht mehr teilgenommen werden.',
  POLL_EXPIRED: 'Das Ende der Umfrage liegt in der Vergangenheit.',
  POLL_INVALID_STATUS: 'Diese Aktion ist im aktuellen Status nicht möglich.',
  POLL_MULTIPLE_VOTES_EXIST:
    'Einige Personen haben bereits mehrere Antworten gewählt. Die Mehrfachauswahl kann deshalb nicht deaktiviert werden.',
  POLL_TOO_FEW_OPTIONS:
    'Eine Umfrage braucht mindestens zwei Antwortmöglichkeiten, außer Teilnehmer dürfen eigene ergänzen.',
  POLL_OPTION_INVALID: 'Bitte gib eine gültige Antwortmöglichkeit ein (höchstens 200 Zeichen).',
  POLL_OPTION_DUPLICATE: 'Jede Antwortmöglichkeit darf nur einmal vorkommen.',
  POLL_OPTIONS_NOT_ALLOWED: 'Bei dieser Umfrage können keine eigenen Antworten ergänzt werden.',
  POLL_SELECTION_REQUIRED: 'Bitte wähle mindestens eine Antwort aus.',
  POLL_SINGLE_CHOICE: 'Bei dieser Umfrage ist nur eine Antwort möglich.',
  STRIPE_REQUEST_FAILED: 'Stripe hat die Anfrage abgelehnt oder nicht beantwortet. Bitte versuche es später erneut.',
  WEBHOOK_SIGNATURE_INVALID: 'Die Stripe-Signatur ist ungültig.',
  MISSING_STRIPE_SIGNATURE: 'Die Stripe-Signatur fehlt.',
  WEBHOOK_CONTEXT_MISSING: 'Die Stripe-Zahlung konnte keinem Mitglied oder Paket zugeordnet werden.',
  DISCOUNT_TITLE_REQUIRED: 'Bitte gib einen Titel für den Rabatt ein.',
  DISCOUNT_TYPE_INVALID: 'Bitte wähle Prozent oder Betrag als Rabattart.',
  DISCOUNT_PERCENT_INVALID: 'Der Prozentrabatt muss größer als 0 und höchstens 100 sein.',
  DISCOUNT_AMOUNT_INVALID: 'Der Rabattbetrag muss größer als 0 sein.',
  DISCOUNT_NOT_FOUND: 'Der Rabatt wurde nicht gefunden oder ist nicht aktiv.',
  UNSAFE_MODE_NOT_ALLOWED: 'Der Stripe-Abgleich darf nur als Probelauf oder mit sicheren Korrekturen laufen.',
  PLAN_CHANGE_RECONCILE_FAILED: 'Der Tarifwechsel konnte noch nicht mit Stripe abgeglichen werden. Es wird erneut versucht.',
  PACKAGE_NOT_MAPPED: 'Der Stripe-Preis ist keinem Paket zugeordnet.',
  USER_NOT_MAPPED: 'Das Stripe-Abo ist keinem Mitglied zugeordnet.',
  SUBSCRIPTION_PRICE_UPDATE_RELATION_INVALID: 'Das Abo passt nicht zu diesem Paket.',
  STRIPE_DISCOUNT_SYNC_TARGET_INVALID: 'Der Rabattabgleich mit Stripe hat kein gültiges Ziel.',
  INVALID_DOCUMENT_KIND: 'Die Belegart ist ungültig.',
  PAYMENT_ENTRY_NOT_FOUND: 'Die Zahlung wurde nicht gefunden.',
  PAYMENT_LINE_CONFLICT: 'Die Rechnungsposition passt nicht zur gespeicherten Zahlung.',
  TEMPLATE_SLUG_INVALID: 'Der Slug darf nur Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten (2–64 Zeichen).',
  TEMPLATE_FIELDS_REQUIRED: 'Bitte Name, Betreff und Text der Vorlage ausfüllen.',
  TEMPLATE_SLUG_DUPLICATE: 'Es gibt bereits eine Vorlage mit diesem Slug.',
  TEMPLATE_NOT_FOUND: 'Die Vorlage wurde nicht gefunden.',
  RECIPIENT_MISSING: 'Bitte gib eine Empfänger-E-Mail-Adresse an.',
  MAIL_SEND_FAILED: 'Die E-Mail konnte nicht versendet werden. Bitte die SMTP-Einstellungen prüfen.',
  HONORARIUM_TIER_INVALID:
    'Die Honorarstaffel ist ungültig: Mindestzahl und Betrag dürfen nicht negativ sein, das Maximum nicht unter dem Minimum liegen und jede Mindestzahl nur einmal vorkommen.',
  HONORARIUM_SESSIONS_REQUIRED: 'Bitte wähle mindestens einen Termin für die Honorarnote aus.',
  HONORARIUM_PERIOD_INVALID: 'Das Ende des Abrechnungszeitraums liegt vor dem Beginn.',
  HONORARIUM_SESSION_INVALID: 'Mindestens ein Termin gehört nicht zu diesem Trainer oder liegt nicht im Zeitraum.',
  HONORARIUM_SESSION_ALREADY_BILLED:
    'Mindestens ein Termin ist bereits auf einer Honorarnote (auch stornierte Honorarnoten zählen; diese vorher löschen).',
  HONORARIUM_NOTE_NOT_FOUND: 'Die Honorarnote wurde nicht gefunden.',
  HONORARIUM_STATUS_INVALID: 'Dieser Status ist für Honorarnoten nicht vorgesehen.',
  HONORARIUM_ALREADY_SENT: 'Die Honorarnote wurde bereits versendet.',
  TRAINER_EMAIL_MISSING: 'Für diesen Trainer ist keine E-Mail-Adresse hinterlegt.',
  POLL_FIELDS_INVALID: 'Bitte Titel, Text und Zielgruppe angeben; das Ende muss nach dem Start liegen.',
  ANNOUNCEMENT_FIELDS_INVALID: 'Bitte Titel, Text und Zielgruppe angeben; das Ende muss nach dem Start liegen.',
  FEEDBACK_INVALID: 'Bitte Titel (höchstens 200 Zeichen) und Text (höchstens 5000 Zeichen) ausfüllen.',
  FEEDBACK_STATUS_INVALID: 'Dieser Status ist für Feedback nicht vorgesehen.',
  FEEDBACK_NOT_FOUND: 'Das Feedback wurde nicht gefunden.',
  CMS_KEY_INVALID: 'Ein Inhaltsfeld hat keinen Schlüssel.',
  CMS_FIELDS_REQUIRED: 'Bitte alle Pflichtfelder der Listen (Fragen, Antworten, Namen, Seiten, Titel) ausfüllen.',
  CHECKOUT_SESSION_REQUIRED: 'Die Stripe-Checkout-Sitzung fehlt.',
  INVOICE_LINES_REQUIRED: 'Die Stripe-Rechnung enthält keine Positionen.',
  INVALID_INVOICE_LINE: 'Eine Position der Stripe-Rechnung ist ungültig.',
  STRIPE_EVENT_REQUIRED: 'Das Stripe-Ereignis fehlt.',
  STRIPE_SUBSCRIPTION_ITEM_COUNT_UNSUPPORTED: 'Stripe-Abos mit mehreren Positionen werden nicht unterstützt.',
  STRIPE_DISCOUNT_SYNC_SCOPE_INVALID: 'Der Rabattabgleich mit Stripe hat einen ungültigen Umfang.',
  STRIPE_DISCOUNT_SYNC_TRIGGER_INVALID: 'Der Auslöser des Rabattabgleichs ist ungültig.',
  SUBSCRIPTION_PRICE_UPDATE_TARGET_INVALID: 'Die Preisänderung hat kein gültiges Abo als Ziel.',
  SUBSCRIPTION_PRICE_UPDATE_TRIGGER_INVALID: 'Der Auslöser der Preisänderung ist ungültig.',
  SUBSCRIPTION_NO_LONGER_ACTIVE: 'Das Abo ist nicht mehr aktiv; die Preisänderung entfällt.',
  SUBSCRIPTION_CANCELLED: 'Das Abo wurde gekündigt; der Auftrag entfällt.',
  PRICE_UPDATE_FAILED: 'Die Preisänderung in Stripe ist fehlgeschlagen.',
  USER_REQUIRED: 'Bitte wähle ein Mitglied aus.',
  USER_NOT_RESOLVED: 'Das Mitglied konnte nicht zugeordnet werden.',
  ROUTE_NOT_FOUND: 'Diese Funktion ist auf dem Server nicht verfügbar. Bitte lade die Seite neu.',
  // Responses without a code (framework validation, auth, gateway); ApiError keeps the HTTP status.
  HTTP_400: 'Die Eingaben sind unvollständig oder ungültig. Bitte prüfe sie.',
  HTTP_401: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  HTTP_403: 'Dafür fehlen dir die Berechtigungen.',
  HTTP_404: 'Der Eintrag wurde nicht gefunden.',
  HTTP_409: 'Die Daten wurden inzwischen geändert. Bitte lade die Seite neu.',
  HTTP_413: 'Die Datei ist zu groß.',
  HTTP_429: 'Zu viele Anfragen. Bitte warte kurz und versuche es erneut.',
  HTTP_500: 'Auf dem Server ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  HTTP_502: 'Der Server ist gerade nicht erreichbar. Bitte versuche es gleich erneut.',
  HTTP_503: 'Der Dienst ist gerade nicht verfügbar. Bitte versuche es gleich erneut.',
  HTTP_504: 'Der Server antwortet nicht rechtzeitig. Bitte versuche es gleich erneut.',
}

/** The German text for a stable error code, or the code itself when it is unknown (e.g. Stripe codes stored on jobs). */
export function translateErrorCode(code: string): string {
  return messages[code] ?? code
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error && error.name === 'TimeoutError') {
    return 'Der Server antwortet nicht rechtzeitig. Bitte prüfe vor einem erneuten Versuch, ob die Aktion bereits durchgeführt wurde.'
  }

  if (error instanceof Error && error.message in messages) {
    return messages[error.message]
  }

  // A code the SPA does not know yet: explain by HTTP status and keep the code for support.
  if (error instanceof ApiError) {
    const byStatus = messages[`HTTP_${error.status}`] ?? 'Die Aktion ist fehlgeschlagen.'
    return error.message.startsWith('HTTP_') ? byStatus : `${byStatus} (${error.message})`
  }

  if (error instanceof TypeError && /fetch|network|load failed/i.test(error.message)) {
    return 'Der Server konnte nicht erreicht werden. Das kann an einer Serverstörung oder an der Verbindung liegen. Bitte versuche es gleich erneut.'
  }

  if (error instanceof Error) {
    const lower = error.message.toLowerCase()
    if (lower.includes('captcha')) {
      return 'Sicherheitsprüfung fehlgeschlagen. Bitte löse das CAPTCHA erneut.'
    }
    return error.message
  }

  return 'Unerwarteter Fehler. Bitte erneut versuchen.'
}
